import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { auth, db } from '../../../firebase-client';
import { doc, getDoc } from 'firebase/firestore';
export default function PaymentSuccessPage() {
  const {
    teamId: teamIdFromParams
  } = useParams();
  const {
    search
  } = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const teamId = teamIdFromParams || new URLSearchParams(search).get('team');
  useEffect(() => {
    let attempt = 0;
    let confirmationTimeout;
    let cancelled = false;

    // backup redirect after 3s
    const backupTimeout = setTimeout(() => {
      if (teamId) navigate(`/teams/${teamId}`, { replace: true });
    }, 3000);
    const interval = setInterval(async () => {
      const user = auth.currentUser; // get fresh value each tick
      if (!user || !teamId) return;
      try {
        const userRef = doc(db, 'users', user.uid);
        const snap = await getDoc(userRef);
        if (cancelled) return;
        const role = snap.exists() ? snap.data()?.team_roles?.[teamId] : null;
        if (role === 'member') {
          clearInterval(interval);
          clearTimeout(backupTimeout);
          setStatus('confirmed');
          confirmationTimeout = setTimeout(() => navigate(`/teams/${teamId}`, { replace: true }), 1000);
        } else if (++attempt > 10) {
          clearInterval(interval);
          setStatus('failed');
        }
      } catch (e) {
        if (cancelled) return;
        clearInterval(interval);
        setStatus('error');
      }
    }, 1500);
    return () => {
      cancelled = true;
      clearInterval(interval);
      clearTimeout(backupTimeout);
      clearTimeout(confirmationTimeout);
    };
  }, [teamId, navigate]);
  return <div className="form-page-container py-12 px-6 text-center max-w-xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Thanks for your payment</h2>
      {status === 'checking' && <p className="text-gray-600">We're setting up your access… please wait.</p>}
      {status === 'confirmed' && <p className="text-green-700 font-medium mt-2">You're all set! Redirecting…</p>}
      {status === 'failed' && <>
          <p className="text-red-600 mt-2">Payment succeeded, but we couldn't confirm your membership.</p>
          <p className="text-sm text-gray-500 mt-1">If this doesn't update in a minute, please contact support.</p>
        </>}
      {status === 'error' && <p className="text-red-600 mt-2">Something went wrong. Please refresh and try again.</p>}
    </div>;
}
